import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ComplianceRiskFormErrorStatesEnum {
    GetIndividualFailed = ErrorStateScheduleEnum.ComplianceRiskFormStatesStartIndex,
    UpdateIndividualFailed
}
